@if (ifs$ | async; as ifs) {
  <app-gc-header
    [iconName]="'receipt'"
    [titleString]="'ordersOverview.modalHeader' | translate"
  />

  <div class="overview-table-control">
    <div class="row">
      <div class="filter-input-wrapper">
        <div class="filtering-component">
          <ipo-input
            [placeholder]="'ordersOverview.filterInputPlaceholder' | translate"
            [value]="filterText"
            [label]="'ordersOverview.formFilterHeader' | translate"
            [showSearchAndClearIcons]="true"
            [type]="'text'"
            (changed)="onFilterTextChanged($event)"
          />
        </div>

        <div class="filtering-component">
          <app-installation-report-filter />
        </div>
      </div>

      @if (showExcelButtons()) {
        <div class="buttons-container">
          @if (!isDeliveryPortalFI || canImportPlannedDates) {
            <gc-button
              [variant]="'secondary'"
              [isLoading]="excelLoadingState()"
              (clicked)="fileUpload.click()"
            >
              {{ 'ordersOverview.importPlannedDates' | translate }}
            </gc-button>
          }

          <gc-button
            [icon]="'download'"
            [isLoading]="excelLoadingState()"
            (clicked)="onDownloadExcel(ifs)"
          >
            {{ 'ordersOverview.downloadExcel' | translate }}
          </gc-button>
        </div>
      }
    </div>

    <div class="divider"></div>
  </div>

  <div class="installation-reporting-wrapper-content">
    @if (isMduSduListingLoading()) {
      <ipo-loading-spinner />
    } @else if (isMduEnabled) {
      <gc-tabs
        [class]="'tabs-container'"
        [initialTabIndex]="resolvedGcTabIndex()"
        (activeTabChanged)="onActiveTabChanged($event)"
      >
        <gc-tab
          [label]="'SDU (' + sduItemCount() + ')'"
          [templateRef]="sduTab"
          [aria-disabled]="checkSduItemCount()"
        />
        <gc-tab
          [label]="'MDU (' + mduItemCount() + ')'"
          [templateRef]="mduTab"
          [aria-disabled]="checkMduItemCount()"
        />
      </gc-tabs>
    } @else {
      <ng-container *ngTemplateOutlet="sduTab" />
    }

    <ng-template #mduTab>
      @if (groupAgreementsResponse(); as groupAgreements) {
        @if (groupAgreements.isLoading) {
          <ipo-loading-spinner />
        }
        <app-group-agreements-table />
      }
    </ng-template>

    <ng-template #sduTab>
      @if (installationReportingResponse(); as sduResponse) {
        @if (
          sduResponse.hasErrors ||
          (!sduResponse.isLoading && (sduResponse.data?.length ?? 0) === 0)
        ) {
          <div class="no-orders">
            <ipo-icon-alert [type]="'warning'">
              {{ 'ordersOverview.error' | translate }}
            </ipo-icon-alert>
          </div>
        } @else {
          <app-installation-reporting-table
            [ifs]="ifs"
            [installationReports]="sduResponse.data ?? []"
            [filterText]="filterText"
            [filterFields]="filterFields"
            [isLoading]="sduResponse.isLoading"
          />
        }
      }
    </ng-template>
  </div>

  <router-outlet />

  <input
    #fileUpload
    (change)="updatePlannedInstallationDates(ifs, $event)"
    multiple="multiple"
    type="file"
    name="picture"
    accept=".xlsx"
    class="file-upload-input"
    [style.display]="'none'"
  />
}

@if (!isInstallationReportModalOpen()) {
  <app-feedback-alert />
  <app-detailed-error-feedback-alert />
}
